import { Action } from 'redux';

import { NewFlowForDatasource } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface NewFlowForDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function newFlowForDatasource(contentInfo: IContentInfo): NewFlowForDatasourceAction {
  return {
    type: NewFlowForDatasource,
    contentInfo
  };
}

export const isNewFlowForDatasourceAction = isActionFactory<NewFlowForDatasourceAction>(NewFlowForDatasource);
